const KEY = "sendMoney.countryCurrency";

export interface CountryCurrency {
  country: string;
  currency: string;
}

export const loadCountryCurrency = (): CountryCurrency | undefined => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as CountryCurrency) : undefined;
  } catch {
    return undefined;
  }
};

export const saveCountryCurrency = (value: CountryCurrency): void => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* storage unavailable — non-fatal */
  }
};

export const clearCountryCurrency = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* non-fatal */
  }
};